import type { QuizResponse } from '@efdigital/ll-addon-data';
import { ToggleState } from '@efdigital/ll-addon-ui';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import BsCollapse from 'ember-bootstrap/components/bs-collapse';

import EditResponse from './edit-response.gts';

interface Signature {
  Args: {
    /**
     * The label to display for this response editor
     */
    label: string;
    /**
     * The response object to edit
     */
    response: QuizResponse;
  };
}

export default class CollapsibleResponse extends Component<Signature> {
  hasContent(response: QuizResponse): boolean {
    return !!(response.markdown?.trim() || response.title?.trim());
  }

  <template>
    <ToggleState @default={{true}} as |toggleState|>
      {{#let (uniqueId) as |collapseId|}}
        <div class="mb-1 border rounded">
          <button
            type="button"
            class="btn btn-white w-100 d-flex align-items-center gap-2 text-start rounded-1 border-0
              {{if toggleState.value 'rounded-bottom-1' 'rounded-bottom-0'}}"
            {{on "click" toggleState.toggle}}
            aria-controls="collapse-{{collapseId}}"
            aria-expanded={{if toggleState.value "false" "true"}}
          >
            <iconify-icon
              inline
              icon={{if toggleState.value "ph:caret-right" "ph:caret-down"}}
              class="fs-5"
            />
            <span class="flex-grow-1">
              <strong>{{@label}}</strong>
              {{#if (this.hasContent @response)}}
                <span class="text-muted ms-2">— Has content</span>
              {{else}}
                <span class="text-muted fst-italic ms-2">— (Empty)</span>
              {{/if}}
            </span>
          </button>

          <BsCollapse
            @collapsed={{toggleState.value}}
            id="collapse-{{collapseId}}"
          >
            <div class="p-3 bg-white bg-opacity-25">
              <EditResponse @label={{@label}} @response={{@response}} />
            </div>
          </BsCollapse>
        </div>
      {{/let}}
    </ToggleState>
  </template>
}
